module.exports = __webpack_public_path__ + "img/02.df7c0dbf.jpg";